import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Sidebar.module.scss";
import { IoIosLogOut } from "react-icons/io";
import { useTheme } from "../../../contexts/ThemeContext";
import ThemeIcon from "../../../assets/icons/ThemeIcon";
import ExitIcon from "../../../assets/icons/sidebar/ExitIcon";

const AdminSidebar = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarTop}>
        <div className={styles.logoContainer}>
          <span className={styles.logo}>CleverBotics</span>
          <span className={styles.role}>administrator</span>
        </div>
        <nav className={styles.navigation}>
          <NavLink
            to="/admin/dashboard"
            className={({ isActive }) =>
              isActive
                ? `${styles.navigationButton} ${styles.activeNavigation}`
                : styles.navigationButton
            }
          >
            Статистика
          </NavLink>
          <NavLink
            to="/admin/clients"
            className={({ isActive }) =>
              isActive
                ? `${styles.navigationButton} ${styles.activeNavigation}`
                : styles.navigationButton
            }
          >
            Пользователи
          </NavLink>
        </nav>
      </div>
      <div className={styles.sidebarFooter}>
        <ExitIcon color={theme === "dark" ? "white" : "currentColor"} />
        <button className={styles.servicesButton} onClick={toggleTheme}>
          <ThemeIcon theme={theme} />
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
